// extracted by mini-css-extract-plugin
module.exports = {"titleCenter":"RecommendationSlider_titleCenter__9d341"};